import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/markercollection
 */
import LiveRange from './liverange';
import EmitterMixin from '@ckeditor/ckeditor5-utils/src/emittermixin';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
/**
 * The collection of all {@link module:engine/model/markercollection~Marker markers} attached to the document.
 * It lets you {@link module:engine/model/markercollection~MarkerCollection#get get} markers or track them using
 * {@link module:engine/model/markercollection~MarkerCollection#event:update} event.
 *
 * To create, change or remove makers use {@link module:engine/model/writer~Writer model writers'} methods:
 * {@link module:engine/model/writer~Writer#addMarker} or {@link module:engine/model/writer~Writer#removeMarker}. Since
 * the writer is the only proper way to change the data model it is not possible to change markers directly using this
 * collection. All markers created by the writer will be automatically added to this collection.
 *
 * By default there is one marker collection available as {@link module:engine/model/model~Model#markers model property}.
 *
 * @see module:engine/model/markercollection~Marker
 */

var MarkerCollection = /*#__PURE__*/function () {
  /**
   * Creates a markers collection.
   */
  function MarkerCollection() {
    _classCallCheck(this, MarkerCollection);

    /**
     * Stores {@link ~Marker markers} added to the collection.
     *
     * @private
     * @member {Map} #_markers
     */
    this._markers = new Map();
  }
  /**
   * Iterable interface.
   *
   * Iterates over all {@link ~Marker markers} added to the collection.
   *
   * @returns {Iterable}
   */


  _createClass(MarkerCollection, [{
    key: Symbol.iterator,
    value: function value() {
      return this._markers.values();
    }
    /**
     * Checks if marker with given `markerName` is in the collection.
     *
     * @param {String} markerName Marker name.
     * @returns {Boolean} `true` if marker with given `markerName` is in the collection, `false` otherwise.
     */

  }, {
    key: "has",
    value: function has(markerName) {
      return this._markers.has(markerName);
    }
    /**
     * Returns {@link ~Marker marker} with given `markerName`.
     *
     * @param {String} markerName Name of marker to get.
     * @returns {module:engine/model/markercollection~Marker|null} Marker with given name or `null` if such marker was
     * not added to the collection.
     */

  }, {
    key: "get",
    value: function get(markerName) {
      return this._markers.get(markerName) || null;
    }
    /**
     * Creates and adds a {@link ~Marker marker} to the `MarkerCollection` with given name on given
     * {@link module:engine/model/range~Range range}.
     *
     * If `MarkerCollection` already had a marker with given name (or {@link ~Marker marker} was passed), the marker in
     * collection is updated and {@link module:engine/model/markercollection~MarkerCollection#event:update} event is fired
     * but only if there was a change (marker range or {@link module:engine/model/markercollection~Marker#managedUsingOperations}
     * flag has changed.
     *
     * @protected
     * @fires module:engine/model/markercollection~MarkerCollection#event:update
     * @param {String|module:engine/model/markercollection~Marker} markerOrName Name of marker to set or marker instance to update.
     * @param {module:engine/model/range~Range} range Marker range.
     * @param {Boolean} [managedUsingOperations=false] Specifies whether the marker is managed using operations.
     * @param {Boolean} [affectsData=false] Specifies whether the marker affects the data produced by the data pipeline
     * (is persisted in the editor's data).
     * @returns {module:engine/model/markercollection~Marker} `Marker` instance which was added or updated.
     */

  }, {
    key: "_set",
    value: function _set(markerOrName, range) {
      var managedUsingOperations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var affectsData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var markerName = markerOrName instanceof Marker ? markerOrName.name : markerOrName;

      if (markerName.includes(',')) {
        /**
         * Marker name cannot contain the "," character.
         *
         * @error markercollection-incorrect-marker-name
         */
        throw new CKEditorError('markercollection-incorrect-marker-name', this);
      }

      var oldMarker = this._markers.get(markerName);

      if (oldMarker) {
        var oldRange = oldMarker.getRange();
        var hasChanged = false;

        if (!oldRange.isEqual(range)) {
          oldMarker._attachLiveRange(LiveRange.fromRange(range));

          hasChanged = true;
        }

        if (managedUsingOperations != oldMarker.managedUsingOperations) {
          oldMarker._managedUsingOperations = managedUsingOperations;
          hasChanged = true;
        }

        if (typeof affectsData === 'boolean' && affectsData != oldMarker.affectsData) {
          oldMarker._affectsData = affectsData;
          hasChanged = true;
        }

        if (hasChanged) {
          this.fire('update:' + markerName, oldMarker, oldRange, range);
        }

        return oldMarker;
      }

      var liveRange = LiveRange.fromRange(range);
      var marker = new Marker(markerName, liveRange, managedUsingOperations, affectsData);

      this._markers.set(markerName, marker);

      this.fire('update:' + markerName, marker, null, range);
      return marker;
    }
    /**
     * Removes given {@link ~Marker marker} or a marker with given name from the `MarkerCollection`.
     *
     * @protected
     * @fires module:engine/model/markercollection~MarkerCollection#event:update
     * @param {String} markerOrName Marker or name of a marker to remove.
     * @returns {Boolean} `true` if marker was found and removed, `false` otherwise.
     */

  }, {
    key: "_remove",
    value: function _remove(markerOrName) {
      var markerName = markerOrName instanceof Marker ? markerOrName.name : markerOrName;

      var oldMarker = this._markers.get(markerName);

      if (oldMarker) {
        this._markers.delete(markerName);

        this.fire('update:' + markerName, oldMarker, oldMarker.getRange(), null);

        this._destroyMarker(oldMarker);

        return true;
      }

      return false;
    }
    /**
     * Fires an {@link module:engine/model/markercollection~MarkerCollection#event:update} event for the given {@link ~Marker marker}
     * but does not change the marker. Useful to force {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher downcast
     * conversion} for the marker.
     *
     * @protected
     * @fires module:engine/model/markercollection~MarkerCollection#event:update
     * @param {String} markerOrName Marker or name of a marker to refresh.
     */

  }, {
    key: "_refresh",
    value: function _refresh(markerOrName) {
      var markerName = markerOrName instanceof Marker ? markerOrName.name : markerOrName;

      var marker = this._markers.get(markerName);

      if (!marker) {
        /**
         * Marker with provided name does not exists.
         *
         * @error markercollection-refresh-marker-not-exists
         */
        throw new CKEditorError('markercollection-refresh-marker-not-exists', this);
      }

      var range = marker.getRange();
      this.fire('update:' + markerName, marker, range, range, marker.managedUsingOperations, marker.affectsData);
    }
    /**
     * Returns iterator that iterates over all markers, which ranges contain given {@link module:engine/model/position~Position position}.
     *
     * @param {module:engine/model/position~Position} position
     * @returns {Iterable.<module:engine/model/markercollection~Marker>}
     */

  }, {
    key: "getMarkersAtPosition",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getMarkersAtPosition(position) {
      var _iterator, _step, marker;

      return _regeneratorRuntime.wrap(function getMarkersAtPosition$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(this);
              _context.prev = 1;

              _iterator.s();

            case 3:
              if ((_step = _iterator.n()).done) {
                _context.next = 10;
                break;
              }

              marker = _step.value;

              if (!marker.getRange().containsPosition(position)) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return marker;

            case 8:
              _context.next = 3;
              break;

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);

              _iterator.e(_context.t0);

            case 15:
              _context.prev = 15;

              _iterator.f();

              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, getMarkersAtPosition, this, [[1, 12, 15, 18]]);
    })
    /**
     * Returns iterator that iterates over all markers, which intersects with given {@link module:engine/model/range~Range range}.
     *
     * @param {module:engine/model/range~Range} range
     * @returns {Iterable.<module:engine/model/markercollection~Marker>}
     */

  }, {
    key: "getMarkersIntersectingRange",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getMarkersIntersectingRange(range) {
      var _iterator2, _step2, marker;

      return _regeneratorRuntime.wrap(function getMarkersIntersectingRange$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(this);
              _context2.prev = 1;

              _iterator2.s();

            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context2.next = 10;
                break;
              }

              marker = _step2.value;

              if (!(marker.getRange().getIntersection(range) !== null)) {
                _context2.next = 8;
                break;
              }

              _context2.next = 8;
              return marker;

            case 8:
              _context2.next = 3;
              break;

            case 10:
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](1);

              _iterator2.e(_context2.t0);

            case 15:
              _context2.prev = 15;

              _iterator2.f();

              return _context2.finish(15);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, getMarkersIntersectingRange, this, [[1, 12, 15, 18]]);
    })
    /**
     * Destroys marker collection and all markers inside it.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      var _iterator3 = _createForOfIteratorHelper(this._markers.values()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var marker = _step3.value;

          this._destroyMarker(marker);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this._markers = null;
      this.stopListening();
    }
    /**
     * Iterates over all markers that starts with given `prefix`.
     *
     *		const markerFooA = markersCollection.set( 'foo:a', rangeFooA );
     *		const markerFooB = markersCollection.set( 'foo:b', rangeFooB );
     *		const markerBarA = markersCollection.set( 'bar:a', rangeBarA );
     *		const markerFooBarA = markersCollection.set( 'foobar:a', rangeFooBarA );
     *		Array.from( markersCollection.getMarkersGroup( 'foo' ) ); // [ markerFooA, markerFooB ]
     *		Array.from( markersCollection.getMarkersGroup( 'a' ) ); // []
     *
     * @param prefix
     * @returns {Iterable.<module:engine/model/markercollection~Marker>}
     */

  }, {
    key: "getMarkersGroup",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function getMarkersGroup(prefix) {
      var _iterator4, _step4, marker;

      return _regeneratorRuntime.wrap(function getMarkersGroup$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iterator4 = _createForOfIteratorHelper(this._markers.values());
              _context3.prev = 1;

              _iterator4.s();

            case 3:
              if ((_step4 = _iterator4.n()).done) {
                _context3.next = 10;
                break;
              }

              marker = _step4.value;

              if (!marker.name.startsWith(prefix + ':')) {
                _context3.next = 8;
                break;
              }

              _context3.next = 8;
              return marker;

            case 8:
              _context3.next = 3;
              break;

            case 10:
              _context3.next = 15;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](1);

              _iterator4.e(_context3.t0);

            case 15:
              _context3.prev = 15;

              _iterator4.f();

              return _context3.finish(15);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, getMarkersGroup, this, [[1, 12, 15, 18]]);
    })
    /**
     * Destroys the marker.
     *
     * @private
     * @param {module:engine/model/markercollection~Marker} marker Marker to destroy.
     */

  }, {
    key: "_destroyMarker",
    value: function _destroyMarker(marker) {
      marker.stopListening();

      marker._detachLiveRange();
    }
    /**
     * Fired whenever marker is added, updated or removed from `MarkerCollection`.
     *
     * @event update
     * @param {module:engine/model/markercollection~Marker} marker Updated Marker.
     * @param {module:engine/model/range~Range|null} oldRange Marker range before the update. When is not defined it
     * means that marker is just added.
     * @param {module:engine/model/range~Range|null} newRange Marker range after update. When is not defined it
     * means that marker is just removed.
     */

  }]);

  return MarkerCollection;
}();

export { MarkerCollection as default };
mix(MarkerCollection, EmitterMixin);
/**
 * `Marker` is a continuous parts of model (like a range), is named and represent some kind of information about marked
 * part of model document. In contrary to {@link module:engine/model/node~Node nodes}, which are building blocks of
 * model document tree, markers are not stored directly in document tree but in
 * {@link module:engine/model/model~Model#markers model markers' collection}. Still, they are document data, by giving
 * additional meaning to the part of a model document between marker start and marker end.
 *
 * In this sense, markers are similar to adding and converting attributes on nodes. The difference is that attribute is
 * connected with a given node (e.g. a character is bold no matter if it gets moved or content around it changes).
 * Markers on the other hand are continuous ranges and are characterized by their start and end position. This means that
 * any character in the marker is marked by the marker. For example, if a character is moved outside of marker it stops being
 * "special" and the marker is shrunk. Similarly, when a character is moved into the marker from other place in document
 * model, it starts being "special" and the marker is enlarged.
 *
 * Another upside of markers is that finding marked part of document is fast and easy. Using attributes to mark some nodes
 * and then trying to find that part of document would require traversing whole document tree. Marker gives instant access
 * to the range which it is marking at the moment.
 *
 * Markers are built from a name and a range.
 *
 * Range of the marker is updated automatically when document changes, using
 * {@link module:engine/model/liverange~LiveRange live range} mechanism.
 *
 * Name is used to group and identify markers. Names have to be unique, but markers can be grouped by
 * using common prefixes, separated with `:`, for example: `user:john` or `search:3`. That's useful in term of creating
 * namespaces for custom elements (e.g. comments, highlights). You can use this prefixes in
 * {@link module:engine/model/markercollection~MarkerCollection#event:update} listeners to listen on changes in a group of markers.
 * For instance: `model.markers.on( 'update:user', callback );` will be called whenever any `user:*` markers changes.
 *
 * There are two types of markers.
 *
 * 1. Markers managed directly, without using operations. They are added directly by {@link module:engine/model/writer~Writer}
 * to the {@link module:engine/model/markercollection~MarkerCollection} without any additional mechanism. They can be used
 * as bookmarks or visual markers. They are great for showing results of the find, or select link when the focus is in the input.
 *
 * 1. Markers managed using operations. These markers are also stored in {@link module:engine/model/markercollection~MarkerCollection}
 * but changes in these markers is managed the same way all other changes in the model structure - using operations.
 * Therefore, they are handled in the undo stack and synchronized between clients if the collaboration plugin is enabled.
 * This type of markers is useful for solutions like spell checking or comments.
 *
 * Both type of them should be added / updated by {@link module:engine/model/writer~Writer#addMarker}
 * and removed by {@link module:engine/model/writer~Writer#removeMarker} methods.
 *
 *		model.change( ( writer ) => {
 * 			const marker = writer.addMarker( name, { range, usingOperation: true } );
 *
 * 			// ...
 *
 * 			writer.removeMarker( marker );
 *		} );
 *
 * See {@link module:engine/model/writer~Writer} to find more examples.
 *
 * Since markers need to track change in the document, for efficiency reasons, it is best to create and keep as little
 * markers as possible and remove them as soon as they are not needed anymore.
 *
 * Markers can be downcasted and upcasted.
 *
 * Markers downcast happens on {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:addMarker} and
 * {@link module:engine/conversion/downcastdispatcher~DowncastDispatcher#event:removeMarker} events.
 * Use {@link module:engine/conversion/downcasthelpers downcast converters} or attach a custom converter to mentioned events.
 * For {@link module:engine/controller/datacontroller~DataController data pipeline}, marker should be downcasted to an element.
 * Then, it can be upcasted back to a marker. Again, use {@link module:engine/conversion/upcasthelpers upcast converters} or
 * attach a custom converter to {@link module:engine/conversion/upcastdispatcher~UpcastDispatcher#event:element}.
 *
 * `Marker` instances are created and destroyed only by {@link ~MarkerCollection MarkerCollection}.
 */

var Marker = /*#__PURE__*/function () {
  /**
   * Creates a marker instance.
   *
   * @param {String} name Marker name.
   * @param {module:engine/model/liverange~LiveRange} liveRange Range marked by the marker.
   * @param {Boolean} managedUsingOperations Specifies whether the marker is managed using operations.
   * @param {Boolean} affectsData Specifies whether the marker affects the data produced by the data pipeline
   * (is persisted in the editor's data).
   */
  function Marker(name, liveRange, managedUsingOperations, affectsData) {
    _classCallCheck(this, Marker);

    /**
     * Marker's name.
     *
     * @readonly
     * @type {String}
     */
    this.name = name;
    /**
     * Range marked by the marker.
     *
     * @protected
     * @member {module:engine/model/liverange~LiveRange}
     */

    this._liveRange = this._attachLiveRange(liveRange);
    /**
     * Flag indicates if the marker is managed using operations or not.
     *
     * @private
     * @member {Boolean}
     */

    this._managedUsingOperations = managedUsingOperations;
    /**
     * Specifies whether the marker affects the data produced by the data pipeline
     * (is persisted in the editor's data).
     *
     * @private
     * @member {Boolean}
     */

    this._affectsData = affectsData;
  }
  /**
   * A value indicating if the marker is managed using operations.
   * See {@link ~Marker marker class description} to learn more about marker types.
   * See {@link module:engine/model/writer~Writer#addMarker}.
   *
   * @returns {Boolean}
   */


  _createClass(Marker, [{
    key: "managedUsingOperations",
    get: function get() {
      if (!this._liveRange) {
        throw new CKEditorError('marker-destroyed', this);
      }

      return this._managedUsingOperations;
    }
    /**
     * A value indicating if the marker changes the data.
     *
     * @returns {Boolean}
     */

  }, {
    key: "affectsData",
    get: function get() {
      if (!this._liveRange) {
        throw new CKEditorError('marker-destroyed', this);
      }

      return this._affectsData;
    }
    /**
     * Returns current marker start position.
     *
     * @returns {module:engine/model/position~Position}
     */

  }, {
    key: "getStart",
    value: function getStart() {
      if (!this._liveRange) {
        throw new CKEditorError('marker-destroyed', this);
      }

      return this._liveRange.start.clone();
    }
    /**
     * Returns current marker end position.
     *
     * @returns {module:engine/model/position~Position}
     */

  }, {
    key: "getEnd",
    value: function getEnd() {
      if (!this._liveRange) {
        throw new CKEditorError('marker-destroyed', this);
      }

      return this._liveRange.end.clone();
    }
    /**
     * Returns a range that represents the current state of the marker.
     *
     * Keep in mind that returned value is a {@link module:engine/model/range~Range Range}, not a
     * {@link module:engine/model/liverange~LiveRange LiveRange}. This means that it is up-to-date and relevant only
     * until next model document change. Do not store values returned by this method. Instead, store {@link ~Marker#name}
     * and get `Marker` instance from {@link module:engine/model/markercollection~MarkerCollection MarkerCollection} every
     * time there is a need to read marker properties. This will guarantee that the marker has not been removed and
     * that it's data is up-to-date.
     *
     * @returns {module:engine/model/range~Range}
     */

  }, {
    key: "getRange",
    value: function getRange() {
      if (!this._liveRange) {
        throw new CKEditorError('marker-destroyed', this);
      }

      return this._liveRange.toRange();
    }
    /**
     * Checks whether this object is of the given.
     *
     *		marker.is( 'marker' ); // -> true
     *		marker.is( 'model:marker' ); // -> true
     *
     *		marker.is( 'view:element' ); // -> false
     *		marker.is( 'documentSelection' ); // -> false
     *
     * {@link module:engine/model/node~Node#is Check the entire list of model objects} which implement the `is()` method.
     *
     * @param {String} type
     * @returns {Boolean}
     */

  }, {
    key: "is",
    value: function is(type) {
      return type === 'marker' || type === 'model:marker';
    }
    /**
     * Binds new live range to the marker and detach the old one if is attached.
     *
     * @protected
     * @param {module:engine/model/liverange~LiveRange} liveRange Live range to attach
     * @returns {module:engine/model/liverange~LiveRange} Attached live range.
     */

  }, {
    key: "_attachLiveRange",
    value: function _attachLiveRange(liveRange) {
      if (this._liveRange) {
        this._detachLiveRange();
      } // Delegating does not work with namespaces. Alternatively, we could delegate all events (using `*`).


      liveRange.delegate('change:range').to(this);
      liveRange.delegate('change:content').to(this);
      this._liveRange = liveRange;
      return liveRange;
    }
    /**
     * Unbinds and destroys currently attached live range.
     *
     * @protected
     */

  }, {
    key: "_detachLiveRange",
    value: function _detachLiveRange() {
      this._liveRange.stopDelegating('change:range', this);

      this._liveRange.stopDelegating('change:content', this);

      this._liveRange.detach();

      this._liveRange = null;
    }
    /**
     * Fired whenever {@link ~Marker#_liveRange marker range} is changed due to changes on {@link module:engine/model/document~Document}.
     * This is a delegated {@link module:engine/model/liverange~LiveRange#event:change:range LiveRange change:range event}.
     *
     * When marker is removed from {@link module:engine/model/markercollection~MarkerCollection MarkerCollection},
     * all event listeners listening to it should be removed. It is best to do it on
     * {@link module:engine/model/markercollection~MarkerCollection#event:update MarkerCollection update event}.
     *
     * @see module:engine/model/liverange~LiveRange#event:change:range
     * @event change:range
     * @param {module:engine/model/range~Range} oldRange
     * @param {Object} data
     */

    /**
     * Fired whenever change on {@link module:engine/model/document~Document} is done inside {@link ~Marker#_liveRange marker range}.
     * This is a delegated {@link module:engine/model/liverange~LiveRange#event:change:content LiveRange change:content event}.
     *
     * When marker is removed from {@link module:engine/model/markercollection~MarkerCollection MarkerCollection},
     * all event listeners listening to it should be removed. It is best to do it on
     * {@link module:engine/model/markercollection~MarkerCollection#event:update MarkerCollection update event}.
     *
     * @see module:engine/model/liverange~LiveRange#event:change:content
     * @event change:content
     * @param {module:engine/model/range~Range} oldRange
     * @param {Object} data
     */

  }]);

  return Marker;
}();

mix(Marker, EmitterMixin);
/**
 * Cannot use a {@link module:engine/model/markercollection~MarkerCollection#destroy destroyed marker} instance.
 *
 * @error marker-destroyed
 */